import * as API from "./crud";
import {
  slice,
  actionTypes,
  defaultStatisticsUsers,
  defaultStatisticsTeams,
  defaultStatisticsContacts,
  defaultStatisticsEmyProjects,
  defaultStatisticsEmyServices,
  defaultStatisticsEmyProducts,
  defaultStatisticsNotifications, defaultStatisticsWallet
} from "./slice";

const {actions} = slice;


export const fetchUsersStatistics = () => dispatch => {
  const type = actionTypes.Users;

  return API
      .getUsersStatistics()
      .then(({data:value, status}) => {
        dispatch(actions.fetched({value, type}));
        return {status};
      })
      .catch(({response:{data, status}}) => {
        dispatch(actions.fetched({value: defaultStatisticsUsers, type}));
        return {status};
      });
};

export const fetchTeamsStatistics = () => dispatch => {
  const type = actionTypes.teams;

  return API
    .getTeamsStatistics()
    .then(({data:value, status}) => {
      dispatch(actions.fetched({value, type}));
      return {status};
    })
    .catch(({response:{data, status}}) => {
      dispatch(actions.fetched({value: defaultStatisticsTeams, type}));
      return {status};
    });
};

export const fetchContactsStatistics = () => dispatch => {
  const type = actionTypes.contacts;

  return API
    .getContactStatistics()
    .then(({data:value, status}) => {
      dispatch(actions.fetched({value, type}));
      return {status};
    })
    .catch(({response:{data, status}}) => {
      dispatch(actions.fetched({value: defaultStatisticsContacts, type}));
      return {status};
    });
};

export const fetchEmyProjectsStatistics = () => dispatch => {
  const type = actionTypes.emyProjects;

  return API
    .getEmyProjectsStatistics()
    .then(({data:value, status}) => {
      dispatch(actions.fetched({value, type}));
      return {status};
    })
    .catch(({response:{data, status}}) => {
      dispatch(actions.fetched({value: defaultStatisticsEmyProjects, type}));
      return {status};
    });
};

export const fetchEmyServicesStatistics = () => dispatch => {
  const type = actionTypes.emyServices;

  return API
    .getEmyServicesStatistics()
    .then(({data:value, status}) => {
      dispatch(actions.fetched({value, type}));
      return {status};
    })
    .catch(({response:{data, status}}) => {
      dispatch(actions.fetched({value: defaultStatisticsEmyServices, type}));
      return {status};
    });
};

export const fetchEmyProductsStatistics = () => dispatch => {
  const type = actionTypes.emyProducts

  return API
    .getEmyProductsStatistics()
    .then(({data:value, status}) => {
      dispatch(actions.fetched({value, type}));
      return {status};
    })
    .catch(({response:{data, status}}) => {
      dispatch(actions.fetched({value: defaultStatisticsEmyProducts, type}));
      return {status};
    });
};

export const fetchNotificationsStatistics = () => dispatch => {
  const type = actionTypes.notifications

  return API
    .getNotificationsStatistics()
    .then(({data:value, status}) => {
      dispatch(actions.fetched({value, type}));
      return {status};
    })
    .catch(({response:{data, status}}) => {
      dispatch(actions.fetched({value: defaultStatisticsNotifications, type}));
      return {status};
    });
};

export const fetchWalletStatistics = () => dispatch => {
  const type = actionTypes.wallet

  return API
    .getWalletStatistics()
    .then(({data:value, status}) => {
      dispatch(actions.fetched({value, type}));
      return {status};
    })
    .catch(({response:{data, status}}) => {
      dispatch(actions.fetched({value: defaultStatisticsWallet, type}));
      return {status};
    });
};